module.exports = __webpack_public_path__ + "media/images/countryrect/lu-343be892ced39923cf5bc2010a3d843d.svg";